"use client"

import Script from "next/script"

import { chromeUrls } from "../../lib/site-chrome"

/**
 * Loads the hosted chrome script. It self-invokes `initializeMenu()` when
 * `document.readyState` is past "loading", which `afterInteractive` guarantees,
 * so it runs against the already server-rendered header and footer markup.
 */
export default function ChromeScripts() {
  return <Script src={chromeUrls.scripts} strategy="afterInteractive" />
}
